import { render, staticRenderFns } from "./TabHandover.vue?vue&type=template&id=6985d78d&"
import script from "./TabHandover.vue?vue&type=script&lang=js&"
export * from "./TabHandover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports